module.exports = __webpack_public_path__ + "img/img_022@2x.69fa6733.png";